<div class="row">
    <div class="column small-12">
        <h1 class="middle">{{ 'PAYMENT' | resource:'Passengers' }}</h1>
        <div class="half-gutter">
            <sbw-info-popup [text]="'PAYMENT_POP_UP' | resource:'Passengers':false"></sbw-info-popup>
            {{ 'PAYMENT_INFO' | resource: 'Payment' }}
        </div>
    </div>
</div>
<div class="row">
    <form [formGroup]="creditCardForm">
        <div class="column small-12 medium-6 xlarge-4">
            <select formControlName="creditCard">
                <option *ngFor="let card of model.creditCards" [value]="card.code">{{card.description}}</option>
            </select>
            <div *ngIf="creditCardForm.invalid && creditCardForm.dirty">
                <span class="field-validation-error">{{ 'VALIDATION_SELECT_PAYMENT_TYPE' | resource:'Payment' }}</span>
            </div>
        </div>
    </form>
</div>
